module.exports = __webpack_public_path__ + "static/img/menu_icon.98037c2d.svg";